"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@material-ui/core");
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  display: flex;
  height: 50px;
  margin: 0 auto;
  border-radius: 70px;
  justify-content: center;
  align-items: center;
  align-self: center;
  background: #002eff;
  ${_r10SourceLibrary.Mixins.respondTo.lg(`width:80%;`)}
`;
const StyledButton = (0, _styledComponents.default)(_core.ButtonBase)`
  width: 30px;
  height: 30px;
  margin: auto !important;
  border-radius: 50% !important;
  font-weight: 700;
  justify-content: center;
  background-color: #ffffff !important;
  color: #002eff !important;
  &:disabled {
    color: #bebebe !important;
  }
`;
const StyledText = (0, _styledComponents.default)(_core.Typography)`
  margin: 0 auto !important;
  color: #ffffff;
`;
const IncrementComponent = _ref => {
  let {
    text = '',
    value,
    onChange,
    buttons = {
      left: {
        text: '',
        state: undefined
      },
      right: {
        text: '',
        state: undefined
      }
    },
    planIndex = null
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    columns: {
      sm: 1,
      md: 3
    },
    "data-testid": `additional-plan-calculator-${planIndex}`
  }, /*#__PURE__*/_react.default.createElement(StyledButton, {
    "data-testid": "decrement-btn",
    onClick: () => {
      onChange({
        type: 'decrement',
        value
      });
    },
    disabled: buttons.left.state
  }, buttons.left.text), /*#__PURE__*/_react.default.createElement(StyledText, null, text), /*#__PURE__*/_react.default.createElement(StyledButton, {
    "data-testid": "increment-btn",
    onClick: () => {
      onChange({
        type: 'increment',
        value
      });
    },
    disabled: buttons.right.state
  }, buttons.right.text));
};
var _default = IncrementComponent;
exports.default = _default;